// extracted by mini-css-extract-plugin
export var chip = "_e7-0";
export var filterDropdown = "_e7-5";
export var filterItem = "_e7-6";
export var icon = "_e7-1";
export var removeButton = "_e7-3";
export var removeIcon = "_e7-4";
export var separator = "_e7-2";